"use strict";

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.array.map");

var _toConsumableArray = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/toConsumableArray");

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.object.define-property");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FragmentListView = void 0;

var Table_1 = __importDefault(require("antd/es/table/Table"));

var react_1 = __importDefault(require("react"));

function FragmentListView(_ref) {
  var sections = _ref.sections,
      getRowData = _ref.getRowData,
      tableProps = _ref.tableProps;
  var itemList = sections.reduce(function (acc, section) {
    acc.push.apply(acc, _toConsumableArray(section.items));
    return acc;
  }, []);
  var dataSource = getRowData ? itemList.map(function (item) {
    return getRowData(item);
  }) : [];
  return react_1["default"].createElement(Table_1["default"], Object.assign({
    pagination: false
  }, tableProps, {
    dataSource: dataSource
  }));
}

exports.FragmentListView = FragmentListView;